'use client';

import { createSlice } from '@reduxjs/toolkit';
import { CollectionsStateType } from '../types';

const initialState : CollectionsStateType = {
  collections: [],
  included: [],
  currentPage: 1,
  links: {},
  status: '',
};


export const collectionsSlice = createSlice({
  name: 'collections',
  initialState,
  reducers: {
    changeState: (state, action) => {
      return {
        ...state, ...action.payload
      }
    }
  },
});

export const { changeState } = collectionsSlice.actions;
export default collectionsSlice.reducer;
